<script lang="ts">
    import { gettext as _ } from 'hydria/services/gettext'
    import { notify } from 'hydria/services/notifications'
    import { simpleFetch } from 'hydria/services/session'
    import { sanchor, sgoto, spath } from 'hydria/svelte_helpers'

    import { Breadcrumb } from 'breadcrumb'

    let loading = $state(true)

    function load() {
        simpleFetch('GET', '/json/consent/1/documents')
            .then((r) => {
                loadList(r.data)
                loading = false
            })
            .catch((e) => {
                console.error('Error loading documents:', e)
                notify({ title: $_('Documents'), text: $_('Les résultats n’ont pas pu être chargé.'), type: 'danger' })
                loading = false
            })
    }

    load()

    interface Item {
        id: string
        lg: string
        title: string
        active: boolean
    }

    let items: Item[] = $state([])
    function loadList(data: any) {
        items = data.items
    }

    function createNew() {
        sgoto('/consent-document/new')
    }

    const crumbs = [{ txt: 'Documents de consentement' }]
</script>

<Breadcrumb {crumbs} />

{#if loading}
    <div class="card">
        <div class="card-body">
            <div class="m-4 d-flex justify-content-center align-items-center">
                <div class="spinner-border me-3" role="status" aria-hidden="true"></div>
            </div>
        </div>
    </div>
{:else}
    <div class="card">
        <div class="card-header text-bg-primary">
            <div class="d-flex align-items-center">
                <div class="flex-grow-1 d-flex align-items-baseline gap-2">
                    {$_('Consentement – Documents')}
                </div>
                <div>
                    <button class="btn btn-outline-light btn-sm" type="button" onclick={() => createNew()} disabled={loading}>
                        {$_('Créer un nouveau document')}
                    </button>
                </div>
            </div>
        </div>

        <div class="card-body p-0">
            <table class="table table-hover mb-0" class:disabled-look={loading}>
                <thead class="table-secondary">
                    <tr>
                        <th>{$_('Titre')}</th>
                        <th>{$_('Langue')}</th>
                        <th>{$_('Actif')}</th>
                    </tr>
                </thead>
                {#if !items.length}
                    <tbody>
                        <tr><td colspan={3} class="text-center">{$_('Aucun résultat')}</td></tr>
                    </tbody>
                {:else}
                    <tbody>
                        {#each items as item (item.id)}
                            <tr>
                                <td><a use:sanchor href={spath(`/consent-document/${item.id}`)}>{!item.title ? '[sans titre]' : item.title}</a></td>
                                <td>{item.lg}</td>
                                <td>{item.active ? 'Oui' : ''}</td>
                            </tr>
                        {/each}
                    </tbody>
                {/if}
            </table>
        </div>
    </div>
{/if}
